<template>
  <van-pull-refresh
    v-model="isLoading"
    @refresh="onRefresh"
    :disabled="!pullState"
  >
    <template #pulling>
      <div class="will-refresh">
        <img src="@/assets/img/refresh.png" />
        <font>下拉 即可刷新</font>
      </div>
    </template>
    <template #loosing>
      <div class="will-refresh">
        <img src="@/assets/img/refresh.png" />
        <font>松开 立即刷新</font>
      </div>
    </template>
    <slot></slot>
  </van-pull-refresh>
</template>

<script>
export default {
  name: "PullFresh",
  props: {
    refresh: {
      type: Function
    },
    listRef: {
      type: Object
    },
    pullState: {
      type: Boolean,
      default: true // 开启/关闭  下拉刷新
    }
  },
  data() {
    return {
      isLoading: false,
      list_ref: null
    };
  },
  methods: {
    /**
     *开始更新列表
     *  */
    async onRefresh() {
      if (this.refresh) {
        await this.refresh();
        this.isLoading = false;
      } else {
        //  list更新
        this.listRef.requestList(true);
        this.loadState();
      }
    },
    /**
     * loading状态切换
     */
    loadState() {
      setTimeout(() => {
        if (this.listRef.fresh_finish) {
          this.isLoading = false;
        } else {
          this.loadState();
        }
      }, 100);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .van-pull-refresh__track {
  min-height: 80vh;
  .van-pull-refresh__head {
    height: auto;
  }
}
.will-refresh {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 21px;
    height: 26px;
    margin-right: 30px;
  }
  font {
    font-size: 24px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/PullRefresh.vue